export const ACTIVITY_LIST = 'ACTIVITY_LIST';
export const EXPORT_ACTIVITY = 'EXPORT_ACTIVITY';

export const LADIPAGE_CONTENT_AUDIT_LIST = 'LADIPAGE_CONTENT_AUDIT_LIST';
